import React, { useEffect, useState } from 'react';
import { X, Megaphone } from 'lucide-react';

// ---------------------------------------------------------------------------
// Уведомление об изменениях в вопросах / законодательных документах.
// Ненавязчивый баннер: показывается один раз до закрытия, после закрытия не
// возвращается (значение из localStorage). При публикации новых изменений:
//   - добавь строки в NOTICE.lines,
//   - СМЕНИ NOTICE.id на новое уникальное значение,
// чтобы баннер с обновлённым текстом показался пользователям снова.
// ---------------------------------------------------------------------------
const STORAGE_KEY = 'vohr-changes-seen';

const NOTICE = {
  id: 'prikaz-178-orders-2026-09',
  title: 'Обновление вопросов',
  lines: [
    'Вопросы для периодической проверки приведены в соответствие с приказом Росгвардии от 19.05.2026 №178.',
    'Изменения действуют с 1 сентября 2026 г.',
  ],
};

const UpdateNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) !== NOTICE.id) {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, NOTICE.id);
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <>
      {/* ponytail: style tag, index.css is a frozen Tailwind build, new utilities never emit */}
      <style>{`
        .update-notice { top: auto; bottom: 9rem; }
        @media (width >= 640px) {
          .update-notice { top: 1rem; bottom: auto; }
        }
      `}</style>
      <div
        className="update-notice fixed left-3 right-3 sm:left-auto sm:right-4 sm:max-w-[400px] z-[99998] glass-panel p-3 sm:p-4 rounded-2xl shadow-2xl border border-white/20"
        role="status"
      >
      <div className="flex items-start gap-3">
        <Megaphone className="w-4 h-4 mt-0.5 text-amber-300 flex-shrink-0" />
        <div className="flex-1 flex flex-col gap-1">
          <p className="text-xs font-semibold glass-text uppercase tracking-wide">{NOTICE.title}</p>
          <ul className="flex flex-col gap-1 list-disc list-inside">
            {NOTICE.lines.map((line, i) => (
              <li key={i} className="text-xs sm:text-sm glass-text-secondary leading-snug">
                {line}
              </li>
            ))}
          </ul>
        </div>
        <button
          onClick={handleDismiss}
          className="p-1 rounded-full hover:bg-white/10 transition-colors flex-shrink-0"
          aria-label="Закрыть уведомление"
        >
          <X className="w-4 h-4 text-white/50" />
        </button>
      </div>
      </div>
    </>
  );
};

export default UpdateNotice;